module.exports = __webpack_public_path__ + "51fc4af0b9d45ae8e0583ce7f0bb01f1.pdf";